let audioQueue: string[] = [];
let isLoading: boolean = false;

function preloadSingleAudio(src: string): void {
  audioQueue.push(src);
  processQueue();
}

export default preloadSingleAudio;

function processQueue(): void {
  if (isLoading || audioQueue.length === 0) {
    return;
  }

  isLoading = true;
  const src = audioQueue.shift() as string;

  loadAudio(src)
    .then(() => {
      isLoading = false;
      processQueue();
    })
    .catch((error) => {
      console.error(`Failed to preload ${src}:`, error);
      isLoading = false;
      processQueue();
    });
}

function loadAudio(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const audio = new Audio();
    audio.src = src;
    audio.preload = "auto"; // 确保浏览器尝试完整加载

    // 定义事件处理函数
    const onCanPlayThrough = () => {
      cleanup(); // 移除事件监听器
      resolve();
    };

    const onError = (err: Event) => {
      console.error(`Failed to preload ${src}:`, err);
      cleanup(); // 移除事件监听器
      reject(err);
    };

    // 添加事件监听器
    audio.addEventListener('canplaythrough', onCanPlayThrough);
    audio.addEventListener('error', onError);

    // 显式调用加载音频
    audio.load();

    // 移除事件监听器的函数
    function cleanup() {
      audio.removeEventListener('canplaythrough', onCanPlayThrough);
      audio.removeEventListener('error', onError);
    }
  });
}

